<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Créer un compte')
</script>

<template>
  <q-page flex> Création de compte </q-page>
</template>
